import React from 'react';

import ErrorPage from '@app/src/common/components/error-page/ErrorPage';

const AccessDenied = () => (
  <ErrorPage
    errorCode="403"
    message="error.accessDenied"
  />
);

export default AccessDenied;
